



































import { defineComponent, PropType, ref, computed, ComponentInstance, onUnmounted } from '@vue/composition-api';
import { useInfiniteScroll, templateRef, useDebounceFn } from '@vueuse/core';
import { Issue, Message } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import { useIssue } from '../../hooks/useIssue';
import http from 'common-module/src/util/http';
import { isOverseasVersion } from 'common-module/src/util';
import IssueVxeTable from './IssueVxeTable.vue';
import { RowVO } from './types';
const PAGE_SIZE = 10;

export default defineComponent({
  components: {
    IssueVxeTable
  },
  props: {
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const { openIssue } = useIssue();
    const table = templateRef<ComponentInstance>('table');
    const list = ref<Issue[]>([]);
    const total = ref<number>(0);
    const querySkip = ref<number>(0);
    const finished = ref<boolean>(false);
    const isLoading = ref<boolean>(false);
    const showStayDays = ref<boolean>(false);
    const hasGroup = ref<[]>([]);
    // 获取下一页数据
    const nextQuery = async () => {
      if (finished.value || isLoading.value) {
        return;
      }
      try {
        isLoading.value = true;
        let result = null;
        if (props.message.content.loadListById) {
          showStayDays.value = props.message.content.showStayDays;
          hasGroup.value = props.message.content.hasGroup || [];
          result = await http.post('/chat/issue/query', {
            issueIds: props.message.content.issueIds
          });
        } else {
          result = await http.post('/chat/issue/more', {
            intentCode: 'sql_query',
            params: props.message.content.params,
            queryLimit: PAGE_SIZE,
            querySkip: querySkip.value
          });
        }
        querySkip.value += PAGE_SIZE;
        const { data } = result?.issueResult || {};
        total.value = result?.issueResult?.total || 0;
        list.value = list.value.concat(data || []);
        finished.value = list.value.length >= total.value || (data || []).length < PAGE_SIZE;
        if (hasGroup.value.length > 0) {
          const b = [] as any[];
          hasGroup.value.forEach((item: any) => {
            if (item.issueIds?.length > 0) {
              b.push(item);
              item.issueIds?.forEach((id: number) => {
                const find = data.find((i: RowVO) => i.id === id);
                if (find) {
                  b.push(find);
                }
              });
            }
          });
          list.value = b;
        }

        checkAndLoad();
      } catch (e) {
        finished.value = true;
        throw e;
      } finally {
        isLoading.value = false;
      }
    };
    const bodyWrapper = computed(() => {
      // 加载完成和报错后不再监听
      if (finished.value) {
        return null;
      }
      return (table.value?.$refs?.tableBody as ComponentInstance)?.$el as HTMLElement;
    });

    useInfiniteScroll(bodyWrapper, nextQuery, {
      distance: 10
    });
    const checkAndLoad = () => {
      if (bodyWrapper.value && !isLoading.value) {
        const { scrollHeight, clientHeight } = bodyWrapper.value;
        const isNarrower = scrollHeight <= clientHeight;
        if (isNarrower) {
          nextQuery();
        }
      }
    };
    // 改变大小时，判断是否需要加载更多
    const onResize = useDebounceFn(checkAndLoad, 1000);
    window.addEventListener('resize', onResize);
    onUnmounted(() => {
      window.removeEventListener('resize', onResize);
    });

    // 初始化时调用一次
    nextQuery();

    return {
      t,
      tc,
      list,
      total,
      isLoading,
      showStayDays,
      toIssue(issue: Issue) {
        openIssue(issue);
      },
      overseas: isOverseasVersion
    };
  }
});
